const PreModule = () => import('@pages/prev/PreModule')
import SelectProfilePage from '@pages/prev/SelectProfilePage'
import SelectClientPage from '@pages/prev/SelectClientPage'
import SelectWorkplacePage from '@pages/prev/SelectWorkplacePage'
import SelectUnitPage from '@pages/prev/SelectUnitPage'
import SelectVenuePage from '@pages/prev/SelectVenuePage'
import SelectVenueForInternalsPage from '@pages/prev/SelectVenueForInternalsPage'
import SelectVenueForGuardsPage from '@pages/prev/SelectVenueForGuardsPage'
import authGuard from '../authGuard'
import repo from '@repo/repo.js'
import store from '@store/index.js'
import ls from '@utils/localStorage.js'
import * as mutations from '@store/_mutations'
const ShiftIndex = () => import('@pages/shifts/Index')
//const UserAccount = () => import('@pages/core/userAccount/UserAccountIndex')
const ChangePasswordPage = () => import('@pages/prev/ChangePasswordPage')
const PendingAssgnments = () => import('@pages/shifts/PendingAssignments')
const GuardIndicators = () => import('@pages/vigilance/indicators/GuardIndicators.vue')

export default {
    path: '/pre',
    component: PreModule,
    children: [
        {
            path: 'select-profile',
            component: SelectProfilePage,
            name: 'selectProfilePage',
        },
        {
            path: 'select-client',
            component: SelectClientPage,
            name: 'selectClientPage',
        },
        {
            path: 'select-unit',
            component: SelectUnitPage,
            name: 'selectUnitPage',
        },
        {
            path: 'select-venue',
            component: SelectVenuePage,
            name: 'selectVenuePage',
        },
        {
            path: 'select-venue-internals',
            component: SelectVenueForInternalsPage,
            name: 'selectVenueForInternalsPage',
        },
        {
            path: 'select-venue-guards',
            component: SelectVenueForGuardsPage,
            name: 'selectVenueForGuardsPage',
        },
        {
            path: 'select-workplace',
            component: SelectWorkplacePage,
            name: 'selectWorkplacePage',
        },
        {
            path: 'start-shift',
            component: ShiftIndex,
            name: 'startShift',
        },
        {
            path: 'end-shift/:currentShiftId',
            component: ShiftIndex,
            name: 'endShift',
            props: true,
        },
        {
            path: 'pending-assignments',
            component: PendingAssgnments,
            name: 'pendingAssignments',
        },
        {
            path: 'change-password-page',
            component: ChangePasswordPage,
            name: 'changePasswordPage',
        },
        {
            path: 'guard-indicators',
            component: GuardIndicators,
            name: 'guardIndicators',
        },
        // {
        //     path: 'venues/:venueId/management-report',
        //     component: ManagementReport,
        //     name: 'managementReport',
        //     props: true,
        // },
    ],
    beforeEnter: async (to, from, next) => {
        const payload = to.query.p
        if (!payload) {
            let theState = ls.get()
            if (!!theState) {
                store.commit(mutations.SET_STATE, theState)
            }
            let isAuthenticated = store.getters.isAuthenticated
            if (isAuthenticated) return next()
            return next({
                name: 'login',
            })
        } else {
            try {
                const { data } = await repo.post('validate-user', { payload })
                if (data) {
                    store.commit('SET_CURRENT_USER', data)
                    next()
                }
            } catch (error) {
                // Si hay un error, se retorna con código de error 2
                next({
                    name: 'login',
                    query: { error: 2 },
                })
            }
        }
    },
}
